export default {
    login: "Bejelentkezés",
    logout: "Kijelentkezés",
    home: "Otthon",
    user: {
        profile: {
            edit: "Profil szerkesztése"
        }
    },
    approvals: {
        approvals: "Jóváhagyások",
        delegates: "Küldöttek"
    },
    impersonation: "Rendelés a nevében"
}